__webpack_require__.p = "/breakingmedia/assets/";